import useGetCustomProperties from './useGetCustomProperties';
import useHasAllGates from 'messaging-management-lib/user/hooks/useHasAllGates';
import { useMemo } from 'react';
export default function useHasCustomProperties({
  objectTypeId,
  requiredGates
}) {
  const hasAllGates = useHasAllGates();
  const hasRequiredGates = useMemo(() => {
    return hasAllGates(requiredGates);
  }, [hasAllGates, requiredGates]);
  const {
    customProperties
  } = useGetCustomProperties({
    objectTypeId,
    requiredGates
  });
  return useMemo(() => hasRequiredGates ? customProperties.length > 0 : false, [customProperties.length, hasRequiredGates]);
}